module.exports = __webpack_public_path__ + "img/diners.62eb899c.svg";